export default __webpack_public_path__ + "static/media/available_loan-button.52b2d660.png";